import {ActionReducerMapBuilder, PayloadAction} from '@reduxjs/toolkit';

import {TTableColumnFilters} from 'components/@common/widgets/custom-table/table-column-filter/use-table-column-filter/use-table-column-filter-types';

import {ITableReportSliceState} from '../table-report-slice-types';
import {
    loadTableReportColumnFilters,
    loadTableReportFilterConditions,
    loadTableReportFilterConditionsWithAttributes,
} from './table-report-column-filters-thunks';

export const createTableReportColumnFiltersReducer = <S extends ITableReportSliceState>() => ({
    setTableColumnFilters(state: S, {payload}: PayloadAction<{
        filters: TTableColumnFilters | undefined; noFetch?: boolean;}>) {
        state.reportOptions.filters = payload.filters;
        state.reportOptions.noFetchWithFilters = !!payload.noFetch;
    },
});

export const createTableReportColumnFiltersExtraReducer = (
    builder: ActionReducerMapBuilder<ITableReportSliceState>,
) => {
    builder.addCase(loadTableReportFilterConditions.fulfilled, (state, {payload}) => {
        state.filterConditions = payload;
    });
    builder.addCase(loadTableReportFilterConditionsWithAttributes.fulfilled, (state, {payload}) => {
        state.filterConditions = payload.filterConditions;
        state.tableAttributes = payload.reportAttributes;
    });
    builder.addCase(loadTableReportColumnFilters.fulfilled, (state, {payload}) => {
        const {columnName, filters} = payload;
        state.reportOptions.savedFilters[columnName] = filters;
    });
};
